import VBreadcrumbs from './VBreadcrumbs'
import VBreadcrumbsItem from './VBreadcrumbsItem'
import VBreadcrumbsDivider from './VBreadcrumbsDivider'

export { VBreadcrumbs, VBreadcrumbsItem, VBreadcrumbsDivider }

export default {
  $_ifrontui_subcomponents: {
    VBreadcrumbs,
    VBreadcrumbsItem,
    VBreadcrumbsDivider,
  },
}
